import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';
import { map, catchError, shareReplay } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class RsaServiceData {
  constructor(private http: HttpClient) {}

  /**
   * Update RSA Provided Service History
   * @param id The RSA Provided record ID
   * @param status The new status (should be 'Completed' to add new history)
   * @param comments The comment for the history entry
   */
  updateRsaServiceProvidedHistory(id: string, status: string, comments: string): Observable<any> {
    return this.http.post(`${environment.apiUrl}/rsaservice/updateRsaServiceProvidedHistory`, {
      id,
      status,
      comments
    });
  }

  /**
   * Get RSA Service Provided Report
   * @param fromDate YYYY-MM-DD
   * @param toDate YYYY-MM-DD
   */
  getRSAServiceProvidedReport(fromDate: string, toDate: string) {
    return this.http.get<any[]>(`${environment.apiUrl}/rsaservice/getRSAServiceProvided`, {
      params: { fromDate, toDate }
    }).pipe(
      map(data => data || []),
      catchError(() => of([])),
      shareReplay(1)
    );
  }
}
